<!-- 选择校区 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="campus" type="campus" :clearable="config.clearable === undefined ? true: config.clearable" />
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-校区选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => null,
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
          defaultCampus: false,
          clearable: true,
        };
      },
    },
    label: {
      type: String,
      default: '校区：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const { user } = inject('store');
    let initCampus = props.config.multiple ? [] : '';
    if (props.config.defaultCampus) {
      initCampus = props.config.multiple ? [user.value.defaultCampusId] : user.value.defaultCampusId;
    }
    const campus = useQuery('campus', props.value || initCampus);

    return {
      campus,
      set(val) {
        campus.value = val;
      },
    };
  },
};
</script>
